module.exports = __webpack_public_path__ + "img/AufDemForcki.9b25f94c.jpg";